<div *ngIf="elsaControl.hasError(ELSA_VALIDATION_FORMS_KEY)" class="d-flex flex-column align-items-end">
  <span class="text-danger font-weight-light form-error-elsa text-capitalize mt-2" *ngFor="let error  of elsaControl.getError(ELSA_VALIDATION_FORMS_KEY)">{{error}}</span>
</div>
